import { Input } from "components/Inputs";
import Datasource, { DatasourceResponse } from "lib/datasource";
import _ from "lodash";
import React, { memo, useEffect, useState, useCallback } from "react";

interface Props {
	propertyId: string;
	preselectedBuildingId?: string;
	onChange?: (buildingId: string) => void;
}

const constraints = {
	name: {
		presence: {
			message: "^ is required",
		},
	},
};

const SelectDynamic = ({ propertyId, onChange, preselectedBuildingId }: Props) => {
	const [options, setOptions] = useState([] as any[]);
	const [defaultState, setDefaultState] = useState({ building_id: preselectedBuildingId } as any);
	const [datasource] = useState(
		new Datasource({
			mainModelName: "building",
			perPage: 1000,
			currentPage: 1,
			sortBy: "name",
		})
	);

	// console.log({ preselectedBuildingId, defaultState });

	const onSelectOption = useCallback(
		(buildingId: string) => {
			if (!_.isNil(onChange)) onChange(buildingId);
			setDefaultState({ building_id: buildingId });
		},
		[onChange]
	);

	useEffect(() => {
		let sub = datasource.responseSubject$.subscribe((response: DatasourceResponse) => {
			const options = _.map(response.normalizedMainModelResponse, (building: any) => {
				return {
					item: building,
					value: building.id,
					label: _.compact([building.name, building.precinct.name]).join(" "),
				};
			});
			const index = preselectedBuildingId ? options.findIndex((option) => option.item.id === preselectedBuildingId) : 0;
			onSelectOption(_.get(options[index], "value"));
			setOptions(options);
		});
		return () => sub.unsubscribe();
	}, [datasource, onSelectOption, preselectedBuildingId]);

	// API call
	useEffect(() => {
		if (_.isEmpty(propertyId)) return;
		datasource.get("v2", "buildings", {
			queryStringParameters: {
				property_id: propertyId,
				sort: datasource.sortBy,
				per_page: datasource.perPage,
				page: datasource.currentPage,
			},
		});
	}, [datasource, propertyId, datasource.currentPage, datasource.perPage, datasource.sortBy]);

	if (_.isEmpty(propertyId) || options.length === 0) return null;

	return (
		<Input
			onChange={onSelectOption}
			name="building_id"
			defaultState={defaultState}
			required={constraints}
			options={options}
			showIf={true}
		/>
	);
};

export default memo(SelectDynamic);
